import React, { useContext, useEffect, useState } from 'react';
import { Context } from '@routes/private/Editor/Context';
import { IProps } from './types';
import * as S from './styles';
import C from '@assets/themes/colors';
import CropIcon from '@assets/icons/cropIcon';
import ToolTip from '@components/Tooltip';


const EditImageCommandOption : React.FC<IProps> = () => {
  const { editorStatus, onShowCropImage } = useContext(Context);
  const [isActive, setIsActive] = useState(false)
  let context = useContext(Context);  
  

  const SetPicker=()=>
  {
      const picker = (context.editorStatus.currentPicker==="EditImage")?undefined:"EditImage";
      context.onShowPicker(picker);
    }




  return (
    <S.Root>
      <ToolTip
        tip="Edit Image"
      >
       <S.ButtonContainer onClick={()=> { SetPicker()}}  backgroundColorValue={context.editorStatus.currentPicker==="EditImage" ? C.DARK_BLUE : 'auto'}>
          Edit Image
        </S.ButtonContainer>
      </ToolTip>      
    </S.Root>
  );
}

export default EditImageCommandOption;